import { analytics } from './analytics';

const UTM_PARAMETERS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_campaign_name',
  'utm_term',
  'utm_content'
];

export function RudderStack() {
  if (!window.location.search) return;

  const query = new URLSearchParams(window.location.search);
  const properties = Object.fromEntries(
    UTM_PARAMETERS
      .filter((name) => query.has(name))
      .map((name) => [name, query.get(name)])
  );
  if (Object.keys(properties).length === 0) return;

  analytics.track('PWS UTM parameters', properties);
}
